import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { founderAdminApi } from '@/lib/founderApi';
import { errMsg, formatPrice } from '@/lib/digitalApi';

export const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : '—');
export const STATUS_CLS = { active: 'text-emerald-700', revoked: 'text-red-700', refunded: 'text-red-700' };

const btn = 'text-xs uppercase tracking-[0.14em] px-4 py-2 border rounded-full';

export const EntitlementDrawer = ({ id, onClose, onChanged }) => {
  const [e, setE] = useState(null);
  const load = () => founderAdminApi.entitlement(id).then(setE).catch((err) => toast.error(errMsg(err)));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [id]);

  const act = async (action) => {
    const prompts = { revoke: 'Remove this customer\u2019s Workspace access? Their blueprint data is kept.', restore: 'Restore Workspace access for this customer?' };
    if (prompts[action] && !window.confirm(prompts[action])) return;
    try {
      const r = await founderAdminApi.action(id, action);
      toast.success(action === 'resend-access' ? (r.email_sent ? 'Sign-in link sent' : 'Email could not be sent') : 'Done');
      await load();
      onChanged();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="fixed inset-0 z-50 flex" data-testid="fb-entitlement-drawer">
      <div className="flex-1 bg-black/40" onClick={onClose} />
      <div className="w-full max-w-xl bg-[#FAF8F5] h-full overflow-y-auto shadow-2xl" data-lenis-prevent>
        <div className="sticky top-0 bg-[#FAF8F5] border-b border-[#eae4d8] px-6 py-4 flex justify-between">
          <div className="text-[10px] tracking-[0.22em] uppercase text-[#888]">Customer access</div>
          <button onClick={onClose} className="text-sm text-[#555]" data-testid="fb-drawer-close">Close ×</button>
        </div>
        {!e ? <div className="py-16 text-center text-[#888]">Loading…</div> : (
          <div className="px-6 py-6 space-y-6 text-sm">
            <div>
              <div className="text-2xl" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>{e.order?.first_name || '—'}</div>
              <div className="text-[#555]">{e.email}</div>
              <div className={`mt-1 text-xs uppercase tracking-[0.14em] ${STATUS_CLS[e.status]}`} data-testid="fb-drawer-status">{e.status}</div>
            </div>
            <div className="bg-white border border-[#eae4d8] rounded-xl p-4 grid grid-cols-2 gap-2">
              <div>Order: {e.order?.status}</div>
              <div>Amount: {formatPrice(e.order?.amount_cents)}</div>
              <div>Paid: {fmt(e.order?.paid_at)}</div>
              <div>Granted: {fmt(e.granted_at)}</div>
              <div>Access email: <span data-testid="fb-drawer-access-email">{fmt(e.access_email_sent_at)}</span></div>
              <div>Last sign-in: {fmt(e.customer?.last_login_at)}</div>
              <div className="col-span-2">Blueprint created: {fmt(e.blueprint?.created_at)}</div>
            </div>
            <div className="flex flex-wrap gap-2">
              {e.status === 'active' && <button onClick={() => act('resend-access')} className={`${btn} border-[#111]`} data-testid="fb-action-resend-access">Send Sign-In Link</button>}
              {e.status === 'active' && <button onClick={() => act('revoke')} className={`${btn} border-red-700 text-red-700`} data-testid="fb-action-revoke">Revoke Access</button>}
              {e.status !== 'active' && <button onClick={() => act('restore')} className={`${btn} border-[#111]`} data-testid="fb-action-restore">Restore Access</button>}
            </div>
            <div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-[#888] mb-2">Activity</div>
              <div className="bg-white border border-[#eae4d8] rounded-xl divide-y divide-[#eae4d8]" data-testid="fb-drawer-activity">
                {[...(e.activity_log || [])].reverse().map((a, i) => (
                  <div key={i} className="p-3 flex justify-between gap-4"><span>{a.action}{a.detail ? ` · ${a.detail}` : ''}</span><span className="text-xs text-[#888]">{fmt(a.at)}</span></div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
